var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"definitions"},_vm._l((_vm.definitions),function(definition,name){return _c('li',[_c('div',{staticClass:"name"},[_vm._v(_vm._s(name))]),_c('div',{staticClass:"definition"},[_vm._v(_vm._s(definition))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }